import React from 'react';
import { AlertStyle, RowDiv } from 'styles/Common';
import { Text } from 'styles';
import { Button } from 'components';
import { Icon } from 'components/common/Icon';
import { Dim } from './Dim';

export function Alert({ content, confirm, title, type, ...props }) {
  return (
    <Dim>
      <AlertStyle>
        {type === 'error' && <Icon name="error" $width={32} $height={28} $marginBottom={24} />}
        {title && (
          <Text $fontSize={20} $fontWeight={700} {...props}>
            {title}
          </Text>
        )}
        <RowDiv $margin={(type === 'error' && '10px 0 24px') || '24px 0'}>{content}</RowDiv>
        {(type === 'error' && <Button label="확인" color="primary" $radius={2} $width="100%" onClick={confirm.onClick} />) || (
          <Button label="닫기" color="gray" type="cancel" onClick={confirm.onClick} $width="100%" />
        )}
      </AlertStyle>
    </Dim>
  );
}
